import { SkiPass, Trip } from "@/types";
import { getTripById, updateTrip } from "./tripService";

export const skiPassService = {
  addSkiPass: async (tripId: string, skiPassData: Omit<SkiPass, "id">) => {
    const trip = await getTripById(tripId);
    if (!trip) {
      throw new Error("Trip not found");
    }
    const newSkiPass: SkiPass = { ...skiPassData, id: `sp-${Date.now()}` };
    const updatedSkiPasses = [...(trip.skiPasses || []), newSkiPass];
    await updateTrip({ ...trip, skiPasses: updatedSkiPasses });
  },

  updateSkiPass: async (tripId: string, updatedSkiPass: SkiPass) => {
    const trip = await getTripById(tripId);
    if (!trip) {
      throw new Error("Trip not found");
    }
    const updatedSkiPasses = (trip.skiPasses || []).map((sp) =>
      sp.id === updatedSkiPass.id ? updatedSkiPass : sp
    );
    await updateTrip({ ...trip, skiPasses: updatedSkiPasses });
  },

  deleteSkiPass: async (tripId: string, skiPassId: string) => {
    const trip = await getTripById(tripId);
    if (!trip) {
      throw new Error("Trip not found");
    }
    const updatedSkiPasses = (trip.skiPasses || []).filter(
      (sp) => sp.id !== skiPassId
    );
    await updateTrip({ ...trip, skiPasses: updatedSkiPasses });
  },
};
